import './tokens.css'
import { useState } from 'react'
import { useEffect } from 'react'

export default function HandleToken({token, lemma, annotation, query, domain, UD}) {

   const [redToken, setRedToken] = useState('')

   useEffect(()=> {
      
      if (domain === "lemma") {
         setRedToken(lemma)
      } else if (domain === "annot") {
         setRedToken(annotation)
      } else if (domain === 'UD') {
         setRedToken(UD)
      } else if (domain === 'full') {

         setRedToken('')
      }

   }, [lemma, annotation, UD, domain])
   
  

   function handleRedToken (domain, query, redToken) {
   

      if (domain === "lemma") {
          return redToken === query
      } else if (domain === 'annot') {
          let answer = false;
          let queryString = query;
          queryString = query.replace('?', '.');
            queryString += ".*"
           let re = new RegExp(queryString);
          answer = redToken.startsWith(query) || redToken.match(re)
         return answer
      } else if (domain === 'UD') {
          let answerUD = false;
          let queryStringUD = query;
          queryStringUD = query.replace(':?', '.*');
          let reUD = new RegExp(queryStringUD);
          answerUD = redToken.startsWith(query) || redToken.match(reUD)
         return answerUD
      } else if (domain === 'full') {

         return false
      }
   }


    return (
      
             <span className={handleRedToken(domain, query, redToken)  ? "tok target" : "tok"}><b>{token}</b> <span className="ext">lemma: <i>{lemma}</i><br/>
                <b>{annotation}</b><br/>
             </span> </span>

    )
    
    }

